import { Link } from 'react-router-dom';
import { siteInfo, socialLinks } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-football-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors"
                  aria-label={link.name}
                >
                  <i className={`${link.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快捷导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</Link>
              {categories.map((cat) => (
                <Link key={cat.id} to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门文章</h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/article-1" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">开云体育网址最新入口指南</Link>
              <Link to="/article/article-5" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">开云体育注册全流程指南</Link>
              <Link to="/article/article-4" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">安全登录与账户保护</Link>
              <Link to="/article/article-8" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">常见问题汇总解答</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <div className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.contact.phone}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.contact.email}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-400"></i>
                <span>{siteInfo.contact.workingHours}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between py-5 border-t border-foreground-800 text-xs text-foreground-400">
          <p>&copy; {new Date().getFullYear()} {siteInfo.name} 版权所有</p>
          <div className="flex items-center gap-4 mt-2 sm:mt-0">
            <a href="#" rel="nofollow" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" rel="nofollow" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" rel="nofollow" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}